import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import i18n from 'shared/util/localization';
import localizationConstants from 'shared/util/translation/constants';

import { State } from 'shared/interface';
import { LogOutIcon, ProfileIcon, SettingIcon } from 'shared/icons/icon';

interface Props {
	toggleModalStatus: () => void;
}
const HeaderButtons = (props: Props) => {
	const { t } = i18n;
	const location = useLocation();
	const { avatar } = useSelector((state: State) => state.siteConfig);

	return (
		<div className='d-flex justify-content-space-between align-items-center'>
			{/* <div
				className='header-icons d-flex justify-content-center align-items-center cursor-pointer'
				title={`${t(localizationConstants.notification)}`}
			>
				<NotificationIcon />
			</div> */}
			<Link to='/Profile'>
				<div
					className={`header-icons ${
						location.pathname.includes('Profile') ? 'bg-color--accent-yellow-color' : 'bg-color--greyscale_10'
					} d-flex justify-content-center align-items-center ml-10 cursor-pointer`}
					title={`${t(localizationConstants.profile)}`}
				>
					{avatar && avatar !== '' ? (
						<img
							src={avatar}
							crossOrigin='anonymous'
							alt='profile-image'
							className='full-width full-height object-fit--cover b-radius--6px'
						/>
					) : (
						<ProfileIcon className={`${location.pathname.includes('Profile') ? 'fill--white' : 'fill--blue-color'} `} />
					)}
				</div>
			</Link>
			<Link to='/Settings'>
				<div
					className={`header-icons ${
						location.pathname.includes('settings') ? 'bg-color--accent-yellow-color' : 'bg-color--greyscale_10'
					} d-flex justify-content-center align-items-center ml-10 cursor-pointer`}
					title={`${t(localizationConstants.settings)}`}
				>
					<SettingIcon
						className={`width--18px height--18px ${location.pathname.includes('settings') ? 'fill--white' : 'fill--blue-color'} `}
					/>
				</div>
			</Link>
			<div
				className='header-icons bg-color--greyscale_10 d-flex justify-content-center align-items-center ml-10 cursor-pointer '
				onClick={props.toggleModalStatus}
				title={`${localizationConstants.logout}`}
			>
				<LogOutIcon />
			</div>
		</div>
	);
};

export default HeaderButtons;
